import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Dialog, Typography } from "@mui/material";
import infoIcon from "@iconify/icons-mdi/information-outline";
import { InlineIcon } from "@iconify/react";
import { useOcGetVersion as useGetVersionDI } from "oc/hooks";

export const OcRefreshDialog = ({ useGetVersion = useGetVersionDI }) => {
  const { timeToRefresh, showRefreshDialog, setShowRefreshDialog, onRefresh } =
    useGetVersion();

  const handleCloseRefreshDialog = () => {
    setShowRefreshDialog(false);
  };

  const { t } = useTranslation();

  return (
    <Dialog open={showRefreshDialog}>
      <Box
        width="480px"
        display="flex"
        flexDirection="column"
        alignItems="center"
        padding="42px 24px 32px 24px"
      >
        <InlineIcon icon={infoIcon} width="62px" color="#5E6366" />
        <Box height="38px" />
        <Typography variant="h5">{t("MY_HR_UPDATE_AVAIABLE")}</Typography>
        <Box height="32px" />
        <Typography variant="body1">{t("MY_HR_FIVE_MIN_REFRESH")}</Typography>
        <Box height="42px" />
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          width="108px"
          height="77px"
          style={{
            backgroundColor: "#f1f3f4",
            color: "#cc0033",
            borderRadius: "4px",
            border: "1px solid #C6CACC",
          }}
        >
          <Typography variant="h4" color="#CC0033">
            {timeToRefresh}
          </Typography>
        </Box>
        <Box height="32px" />
        <Button
          variant="contained"
          fullWidth
          color="primary"
          disableElevation
          onClick={onRefresh}
        >
          {t("OC_REFRESH")}
        </Button>
        <Box height="32px" />
        <Button
          onClick={handleCloseRefreshDialog}
          fullWidth
          variant="text"
          color="secondary"
        >
          {t("MY_HR_CLOSE")}
        </Button>
      </Box>
    </Dialog>
  );
};

export default OcRefreshDialog;
